<template>
  <div>
    <div class="field has-addons">
      <p class="control">
        <button class="button is-medium is-link">
          <span>Lista</span>
        </button>
      </p>
      <p class="control">
        <router-link
          tag="span"
          :to="{
            name: 'configurations.accountcreate',
          }"
          class="button is-medium"
          >Crear</router-link
        >
        <!-- <button class="button is-medium">
          <span>Crear</span>
        </button> -->
      </p>
    </div>
    <h1 class="title">Plan de Cuentas</h1>
    <table class="fontMono" style="width: 100%">
      <thead>
        <tr>
          <th style="width: 90px">Código</th>
          <th>Nombre</th>
          <th style="width: 100px">Tipo</th>
          <th style="width: 68px">Tercero</th>
          <th style="width: 43px">Base</th>
          <th style="width: 68px">CCostos</th>
          <th style="width: 35px">Ref</th>
          <th style="width: 73px">Producto</th>
          <th style="width: 33px">Inv</th>
          <th style="width: 33px">Ing</th>
          <th style="width: 33px">Cos</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cuenta, index) in cuentas" :key="index">
          <td :class="clase(cuenta)">{{ cuenta.codigo }}</td>
          <td :class="clase(cuenta)">{{ cuenta.nombre }}</td>
          <td :class="clase(cuenta)">
            {{ cuenta.esRegistro ? "Registro" : "Agrupadora" }}
          </td>
          <td :class="clase(cuenta)">{{ cuenta.tercero ? "Si" : "No" }}</td>
          <td :class="clase(cuenta)">{{ cuenta.base ? "Si" : "No" }}</td>
          <td :class="clase(cuenta)">{{ cuenta.ccosto ? "Si" : "No" }}</td>
          <td :class="clase(cuenta)">{{ cuenta.dctoref ? "Si" : "No" }}</td>
          <td :class="clase(cuenta)">{{ cuenta.producto ? "Si" : "No" }}</td>
          <td :class="clase(cuenta)">{{ cuenta.inventario ? "Si" : "No" }}</td>
          <td :class="clase(cuenta)">{{ cuenta.ingreso ? "Si" : "No" }}</td>
          <td :class="clase(cuenta)">{{ cuenta.costoProd ? "Si" : "No" }}</td>
          <td :class="clase(cuenta)">
            <router-link
              tag="span"
              :to="{
                name: 'configurations.accountedit',
                params: { id: cuenta._id },
              }"
              class="material-icons has-text-link hand"
              >edit</router-link
            >
            <span
              v-if="cuenta.esRegistro"
              class="material-icons has-text-danger hand"
              @click="deleteCuenta(cuenta._id)"
            >
              delete_forever
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      cuentas: [],
    };
  },
  methods: {
    async deleteCuenta(idcuenta) {
      try {
        const result = await apiServices.delete(`/cuenta/${idcuenta}`);
        if (result.data && result.data.message) {
          this.$store.dispatch("notify", {
            message: result.data.message,
            type: "is-danger",
            position: "top-center",
          });
        } else {
          this.$store.dispatch("notify", {
            message: "Cuenta eliminada con éxito.",
            position: "top-center",
          });
          this.findAccout();
        }
      } catch (err) {
        console.log(err);
      }
    },
    clase(cuenta) {
      let returned;
      if (cuenta.tipo[0] === "grupo") {
        returned = "grupo";
      }
      if (cuenta.tipo[0] === "subGrupo") {
        returned = "subGrupo";
      }
      if (cuenta.tipo[0] === "subCuenta") {
        returned = "subCuenta";
      }
      if (cuenta.esRegistro) {
        returned = "cuenta";
      }
      return returned;
    },
    async findAccout() {
      const result = await apiServices.get(`/cuentas`);
      if (result.data) {
        this.cuentas = result.data;
        const order = (orderArray, key) => {
          orderArray.sort((a, b) => {
            return a[key] < b[key] ? -1 : 1;
          });
          return orderArray;
        };
        order(this.cuentas, "codigo");
      }
      try {
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findAccout();
  },
};
</script>

<style lang="scss" scoped>
.grupo {
  color: black;
  font-weight: bold;
  padding-top: 20px;
}
.subGrupo {
  color: black;
  font-weight: bold;
  padding-top: 10px;
}
.subCuenta {
  font-weight: bold;
  padding-top: 5px;
}
.cuenta {
  color: #9e9e9e;
}
</style>


// WEBPACK FOOTER //
// src/components/configurations/accounts/Account.vue